<template>
  <div class="profile" v-if="$store.state.users[$route.params.id]">
    
    <h1 v-if="$store.state.user.uid !== $route.params.id" >{{ $store.state.users[$route.params.id].name }}</h1>
    <div v-else>
      <label for="name">Display Name</label>
      <input id="name" v-model="$store.state.users[$route.params.id].name" type="text">
    </div>
    <img class="profile-image" :src="$store.state.users[$route.params.id].basics.image" :alt="$store.state.users[$route.params.id].name">
    <div v-if="$store.state.user.uid === $route.params.id">
      <label for="image">Profile Image URL</label>
      <input id="image" v-model="$store.state.users[$route.params.id].image" type="text">
    </div>
    <div style="width: 100%">
      <h2>Hosting Events</h2>
      <ul>
        <li class="profile-event flex between" :key="eventKey" v-for="(event, eventKey) in $store.state.users[$route.params.id].events">
          <img :src="event.image" :alt="event.desc" style="height: 48px; width: 48px; object-fit: cover;">
          <b style="flex: 1 1 auto; padding: 0 8px">{{event.basics.title}}</b>
            <span>{{event.datetime.start}}</span>
            <router-link style="margin-left: 16px;" :to="'/events/' + event.id">Details</router-link>
        </li>
      </ul>
    </div>
    <button type="button" v-if="$store.state.users[$route.params.id].name.length > 0 && $store.state.user.uid === $route.params.id" @click="saveProfile($store.state.users[$route.params.id])">
      <i class="fa fa-save"></i> <span>Update Profile</span>
    </button>
  </div>
  <div v-else>
    LOADING PROFILE ...
  </div>
  
</template>

<script>
export default {
  name: 'search',
  data () {
    return {
      msg: 'Underground Music Events',
      showError: false
    }
  },
  methods: {
    saveProfile (payload) {
      payload.collection = 'users'
      this.$store.dispatch('update', payload)
    }
  },
  mounted () {
    this.$store.dispatch('query', {
      type: 'users',
      id: this.$route.params.id
    }).then(() => {
      this.$set(this.$store.state.users, this.$route.params.id, this.$store.state.users[this.$route.params.id])
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
